import { $$reduce, reducer } from "../reduce";
export function fill(...args) {
    const res = $$reduce(fill, args);
    if (res !== undefined) {
        return res;
    }
    let start = args[0] || 0;
    return reducer(() => [], (acc, x) => ((acc[start++] = x), acc));
}
export function fillN(...args) {
    return fill(...args);
}
